"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/TokenError.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');

var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _store = require('web/store');
var _Form = require('web/components/Form');
var _SignupStepHeader = require('../components/SignupStepHeader'); var _SignupStepHeader2 = _interopRequireDefault(_SignupStepHeader);
var _types = require('../types');

const SUPPORT_EMAIL = 'support@bloomtext.com'

const restartSignupFlow = () => _store.history.push(_routes2.default.WELCOME)
const gotoLogin = () => _store.history.push(_routes2.default.LOGIN.ROOT)





const supportLine = (
  _react2.default.createElement('p', { className: "auth-small", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}, "Still stuck? Write to "
        , _react2.default.createElement('a', { href: `mailto:${SUPPORT_EMAIL}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}},  SUPPORT_EMAIL ), "."
  )
)

// The sign-up link screens: one card, no progress, one support address.
const TokenError = ({ tokenStatus }) => {
  if (tokenStatus === _types.WelcomeUserInvalidStatus.SERVER_ERROR) {
    return (
      _react2.default.createElement('div', { className: "signup-step--error auth-stack" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
        , _react2.default.createElement(_SignupStepHeader2.default, {
          iconType: "error",
          title: "Something went wrong"  ,
          subtitle: "We couldn't check your sign-up link. Try again in a moment, or start sign-up again."              , __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
        )
        , _react2.default.createElement(_Form.Button, { onClick: restartSignupFlow, __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, "Start sign-up again"  )
        ,  supportLine 
      )
    )
  }

  if (tokenStatus === _types.WelcomeUserInvalidStatus.TOKEN_USED) {
    return (
      _react2.default.createElement('div', { className: "signup-step--error auth-stack" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
        , _react2.default.createElement(_SignupStepHeader2.default, {
          iconType: "error",
          title: "You've already signed up"   ,
          subtitle: "This link has been used, so your account probably exists. Log in with the email and password you set."                  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
        )
        , _react2.default.createElement(_Form.Button, { onClick: gotoLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, "Log in" )
        , _react2.default.createElement('div', { className: "auth-links", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
          , _react2.default.createElement(_reactrouterdom.Link, { to: _routes2.default.LOGIN.FORGOT_PASSWORD, className: "auth-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}, "Forgot password?" )
        )
        ,  supportLine 
      )
    )
  }

  return (
    _react2.default.createElement('div', { className: "signup-step--error auth-stack" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
      , _react2.default.createElement(_SignupStepHeader2.default, {
        iconType: "error",
        title: "This link no longer works"    ,
        subtitle: "Sign-up links expire, and each one works once. It may also have been copied incompletely. Enter your work email again and we'll send a new link."                         , __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
      )
      , _react2.default.createElement(_Form.Button, { onClick: restartSignupFlow, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}, "Start sign-up again"  )
      ,  supportLine 
    )
  )
}

exports. default = TokenError
